import { render } from "./SegmentsPanel.vue?vue&type=template&id=0ff0cc8a&scoped=true"
import script from "./SegmentsPanel.vue?vue&type=script&lang=js"
export * from "./SegmentsPanel.vue?vue&type=script&lang=js"

import "./SegmentsPanel.vue?vue&type=style&index=0&id=0ff0cc8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff0cc8a"]])

export default __exports__